// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const basculegion_male: PokeData = {
  "id": 902,
  "name": "basculegion-male",
  "height": 30,
  "weight": 1100,
  "base_experience": 265,
  "types": [
    PokeType.WATER,
    PokeType.GHOST
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "bite",
    "water-gun",
    "flail",
    "scary-face",
    "crunch",
    "shadow-ball",
    "uproar",
    "zen-headbutt",
    "aqua-jet",
    "head-smash",
    "soak",
    "hex",
    "phantom-force",
    "wave-crash"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "scary-face",
    "crunch",
    "shadow-ball",
    "zen-headbutt",
    "aqua-jet",
    "phantom-force",
    "bubble-beam",
    "whirlpool",
    "rain-dance",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 280,
    "item": null,
    "species": [
      {
        "name": "basculin",
        "order": 551,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "basculegion",
        "order": 902,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 550,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.RECOIL_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 109,
    "ability_power": 157
  },
  "stat_changes": [],
  "catch_rate": 135,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
